
  import { mapActions, mapState } from 'vuex'

  import { LISTING_FILTER_PRICE_HASH } from '~/lib/constants/listing-filters'

  import {
    APP_TRAY_NAMES,
    FLY_IN_NAMES,
    OVERLAYS,
  } from '~/lib/constants/overlays'

  export default {
    data() {
      return {
        LISTING_FILTER_PRICE_HASH,
      }
    },
    computed: {
      ...mapState({
        filters: state => state.listings.filters,
      }),
    },
    methods: {
      ...mapActions({
        setCurrentOverlay: 'overlay/setCurrentOverlay',
      }),
      openFilters(hash) {
        this.setCurrentOverlay({
          desktop: {
            type: OVERLAYS.APP_FLY_IN,
            component: FLY_IN_NAMES.LISTING_FILTERS_FLY_IN,
          },
          mobile: {
            type: OVERLAYS.APP_TRAY,
            component: APP_TRAY_NAMES.LISTING_FILTERS_APP_TRAY,
            options: {
              ...(hash && { hash }),
            },
          },
        })
      },
      getFilterTranslation(filter) {
        return this.$filtersTranslationService.getFilterTranslation(filter)
      },
    },
  }
